import { queryClient } from '../queryClient';

import { createLastWatchedQueryOptions } from './queryOptions';

export function fetchLastWatchedQuery() {
  return queryClient.fetchQuery(createLastWatchedQueryOptions());
}
